import React, { useState } from 'react';

export default function DemParametres() {
  const [notif, setNotif] = useState(true);
  const [dark, setDark] = useState(false);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">Paramètres</h1>
        <p className="text-[#64748B] mt-1">Personnalisez votre expérience.</p>
      </div>
      <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
        <div className="px-6 py-5 bg-gradient-to-r from-indigo-50 to-white border-b border-indigo-100">
          <div className="text-sm text-gray-600">Préférences</div>
          <div className="text-lg font-semibold text-gray-900">Notifications et thème</div>
        </div>
        <div className="p-6 space-y-4">
          <label className="flex items-center justify-between p-3 rounded-lg border border-gray-200">
            <div>
              <div className="font-medium text-gray-900">Activer les notifications</div>
              <div className="text-sm text-gray-500">Recevez des alertes pour les nouveaux devis</div>
            </div>
            <input type="checkbox" checked={notif} onChange={e => setNotif(e.target.checked)} />
          </label>
          <label className="flex items-center justify-between p-3 rounded-lg border border-gray-200">
            <div>
              <div className="font-medium text-gray-900">Mode sombre</div>
              <div className="text-sm text-gray-500">Repos des yeux et meilleur contraste</div>
            </div>
            <input type="checkbox" checked={dark} onChange={e => setDark(e.target.checked)} />
          </label>
        </div>
        <div className="px-6 py-4 border-t border-gray-100 flex items-center justify-end">
          <button className="px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700">Sauvegarder</button>
        </div>
      </div>
    </div>
  );
}